import { StateKey } from 'common/utils/flipState'
import { StoreBenefits } from 'common/types/entities/store'
import { fetchStoreBenefits } from 'common/services/channel'

const initialState: StoreBenefits = {
  user: null,
  customerBenefits: null,
  basicBenefits: null,
  sortedHomeBenefits: null,
}

const FETCH = '/store/general/benefit/FETCH'

// 상품상세에서는 카테고리, 원상품번호 지정시 필터링된 톡톡/스찜 쿠폰 내려옴
export interface BenefitParam {
  talktalkYn?: boolean
  categoryId?: string
  productNo?: string
}

export const fetchBenefits = (
  curState: StateKey,
  storeAccountNo: number,
  benefitParams: BenefitParam,
  headers?: any,
) => async dispatch => {
  const result = await fetchStoreBenefits(storeAccountNo, benefitParams, headers)

  dispatch({
    curState,
    payload: result || initialState,
    type: FETCH,
  })
}

const benefitsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH: {
      return {
        ...action.payload,
      }
    }
    default:
      return state
  }
}

export default benefitsReducer
